<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'

defineSlots<{
  button(p: { toggleDropdown: () => void; open: boolean }): any
  content(p: { toggleDropdown: () => void }): any
}>()

const target = ref<HTMLDivElement | null>(null)
const openDropdown = ref(false)

onClickOutside(target, () => {
  openDropdown.value = false
})

const toggleDropdown = () => {
  openDropdown.value = !openDropdown.value
}
</script>

<template>
  <div ref="target" class="relative w-max">
    <slot
      name="button"
      :toggle-dropdown="toggleDropdown"
      :open="openDropdown"
    />
    <div
      v-if="openDropdown"
      class="absolute top-[50px] z-modal overflow-y-auto rounded border border-gray-200 bg-white shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)]"
    >
      <slot name="content" :toggle-dropdown="toggleDropdown" />
    </div>
  </div>
</template>
